import { ProxyPlaybackDrmConfig, ProxyPlaybackReady } from '@warehouse/object-browser/core';
import { components } from './inventory.openapi';

export type ProxyPlaybackApi = components['schemas']['ProxyPlayback'];

export class ProxyPlaybackAdapter {
	static adapt(playback: ProxyPlaybackApi): ProxyPlaybackReady {
		return {
			status: 'ready',
			manifest: playback.manifest,
			expiresInSeconds: playback.expiresInSeconds,
			...(playback.audioConfig ? { audioConfig: playback.audioConfig } : {}),
			...(playback.outdated ? { outdated: true } : {}),
			drm: this.#adaptDrm(playback.drm),
		} satisfies ProxyPlaybackReady;
	}

	static #adaptDrm(drm: ProxyPlaybackApi['drm']): ProxyPlaybackDrmConfig {
		const { widevine, playready } = drm.licenseServers;
		return {
			licenseServers: {
				...(widevine ? { widevine } : {}),
				...(playready ? { playready } : {}),
			},
			token: drm.token,
			keyIds: drm.keyIds,
		} satisfies ProxyPlaybackDrmConfig;
	}
}
